/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import Header3 from '../../components/header/header-rslhome'
import FooterRSL from '../../components/footer/footer-new'
import Seo from '../../components/common/Seo'
import { useDispatch } from 'react-redux'
import { Box, Typography } from '@mui/material'
import CtaButton from '../../components/buttonWithArrow'
import RslSuperAppBanner from '../../components/RslSuperAppBanner'
import ContactEnquiry from "../../components/contactUs/form";
import { bannerHeight } from "../../utils/bannerHeight";
import { fetchSeoByPage } from "../../lib/seoHelper";


// function CardBox({ icon, title, subtitle, button, href }) {

//     // const handleClick = () => {
//     //     if (href) {
//     //         window.open(href, "_blank", "noopener,noreferrer");
//     //     }
//     // };


//     const handleClick = () => {
//         if (!href) return;

//         if (href.startsWith("mailto:")) {
//             const email = href.replace("mailto:", "");

//             // 1. Try default mail app
//             window.location.href = href;

//             // 2. Fallback ONLY if Chrome & not mobile (means default app likely blocked)
//             const isChrome = navigator.userAgent.includes("Chrome") && !navigator.userAgent.includes("Edg");
//             const isMobile = /Android|iPhone|iPad/i.test(navigator.userAgent);

//             if (isChrome && !isMobile) {
//                 setTimeout(() => {
//                     // If Gmail is already handler, this avoids duplicate
//                     const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;
//                     window.open(gmailUrl, "_blank", "noopener,noreferrer");
//                 }, 600);
//             }

//             return;
//         }

//         // Default open for other URLs
//         window.open(href, "_blank", "noopener,noreferrer");
//     };


//     //     const handleClick = () => {
//     //   if (!href) return;

//     //   if (href.startsWith("mailto:")) {
//     //     const email = href.replace("mailto:", "");
//     //     const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;
//     //     window.open(gmailUrl, "_blank", "noopener,noreferrer");
//     //     return;
//     //   }

//     //   window.open(href, "_blank", "noopener,noreferrer");
//     // };


//     return (
//         <Box
//             sx={{
//                 borderRadius: "16px",
//                 border: "1px solid #E0E0E0",
//                 backgroundColor: "#fff",
//                 boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
//                 textAlign: "center",
//                 p: 3,
//                 width: "100%",
//                 maxWidth: 260,
//                 transition: "all 0.3s ease",
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "start",
//                 "&:hover": {
//                     boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
//                     transform: "translateY(-3px)",
//                 },
//             }}
//         >
//             {/* Icon Box */}
//             <Box
//                 sx={{
//                     width: 60,
//                     height: 60,
//                     borderRadius: "12px",
//                     background: "#75c4c55c",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     mb: 2,
//                     border: "1px solid #288b936e"
//                 }}
//             >
//                 <img src={`${process.env.IMAGE_BASE_URL}${icon}`} alt={title} width={28} height={28} />
//             </Box>

//             {/* Title */}
//             <Typography
//                 variant="h6"
//                 sx={{ fontWeight: 600, color: "#000", mb: 0.5 }}
//             >
//                 {title}
//             </Typography>

//             {/* Subtitle */}
//             <Typography variant="body2" sx={{ color: "#333", mb: 2 }}>
//                 {subtitle}
//             </Typography>

//             {/* Button */}
//             <CtaButton label={button ?? "Book Now"} onClick={handleClick} />
//         </Box>
//     );
// }

function CardBox({ icon, title, subtitle, button, href }) {

    const handleClick = () => {
        if (!href) return;

        // EMAIL SUPPORT LOGIC
        if (href.startsWith("mailto:")) {
            const email = href.replace("mailto:", "");

            const isMobile = /Android|iPhone|iPad/i.test(navigator.userAgent);
            const isChromeDesktop =
                navigator.userAgent.includes("Chrome") &&
                !navigator.userAgent.includes("Edg") &&
                !isMobile;

            // 👉 On mobile devices → use native mail app
            if (isMobile) {
                window.location.href = href;
                return;
            }

            // 👉 Chrome on Mac/Windows → open Gmail only (avoid Apple Mail)
            if (isChromeDesktop) {
                const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;
                window.open(gmailUrl, "_blank", "noopener,noreferrer");
                return;
            }

            // 👉 Other browsers → default mail app
            window.location.href = href;
            return;
        }

        // Default for non-email links
        window.open(href, "_blank", "noopener,noreferrer");
    };

    return (
        <Box
            sx={{
                borderRadius: "16px",
                border: "1px solid #E0E0E0",
                backgroundColor: "#fff",
                boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                textAlign: "center",
                p: 3,
                width: "100%",
                maxWidth: 260,
                transition: "all 0.3s ease",
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                "&:hover": {
                    boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                    transform: "translateY(-3px)",
                },
            }}
        >
            <Box
                sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "12px",
                    background: "#75c4c55c",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                    border: "1px solid #288b936e"
                }}
            >
                <img src={`${process.env.IMAGE_BASE_URL}${icon}`} alt={title} width={28} height={28} />
            </Box>

            <Typography variant="h6" sx={{ fontWeight: 600, color: "#000", mb: 0.5 }}>
                {title}
            </Typography>

            <Typography variant="body2" sx={{ color: "#333", mb: 2 }}>
                {subtitle}
            </Typography>

            <CtaButton label={button ?? "Book Now"} onClick={handleClick} />
        </Box>
    );
}


const ContactUs = ({ meta }) => {
    const CHAT_NUMBER = "+97143977746";

    return (
        <>
            <Seo meta={meta} />
            {/* <Seo pageTitle="Invest in Royal Smart Luxury Buses I UAE" /> */}
            <Header3 />
            <section
                className="hero"
                style={{
                    position: "relative",
                    width: "100%",
                    height: bannerHeight(),
                    overflow: "hidden",
                }}
            >
                {/* Fixed background layer */}
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: bannerHeight(),
                        zIndex: 0,
                    }}
                >
                    {/* Background Image */}
                    <Image
                        src={`${process.env.IMAGE_BASE_URL}/images/bannerImage/1761396130190.svg`}
                        alt="limousine"
                        fill
                        priority
                        sizes="100vw"
                        style={{ objectFit: "cover" }}
                    />
                    {/* Gradient overlay */}
                    <div
                        style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            top: 0,
                            background: "linear-gradient(to top, rgba(255, 255, 255, 0.8) 10%, rgba(0, 0, 0, 0) 40%)", // Deeper blur effect at the bottom
                            zIndex: 1,
                            pointerEvents: "none",
                        }}
                    />
                    {/* Content */}
                    <div className="content">
                        <h1 className="title jura" style={{ color: "black" }}>
                            <span className="scribble-wrap">
                                <span className="scribble-text">Contact</span>
                                <img
                                    src="/img/header/Oval.svg"
                                    alt=""
                                    className="scribble"
                                />
                            </span>{" "}
                            our friendly team
                        </h1>
                    </div>
                </div>
            </section>

            <style jsx>{`
    .hero {
        position: relative;
        width: 100%;
        // min-height: clamp(60vh, 72vh, 80vh);
        min-height: ${bannerHeight()};
        border-radius: 0;
        isolation: isolate;
    }

    .content {
        position: absolute;
        inset: 0;
        z-index: 2;
        display: grid;
        place-items: end center;
        padding: clamp(16px, 4vw, 28px);
        align-content: end;
        gap: clamp(16px, 3vh, 28px);
        padding-bottom: clamp(36px, 10vh, 40px);
        text-align: center;
    }

    .title {
        color: #ffffff;
        font-weight: 600;
        letter-spacing: 0.02em;
        line-height: 1.1;
        margin: 0;
        font-size: clamp(28px, 6.5vw, 52px);
        text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
    }

    .scribble-wrap {
        position: relative;
        display: inline-block;
    }

    .scribble-text {
        position: relative;
        z-index: 2;
    }

    .scribble {
        position: absolute;
        z-index: 1;
        left: -0.1em;
        top: -10px;
        width: clamp(7.5em, 14vw, 13em);
        height: auto;
        transform: rotate(-4deg);
        pointer-events: none;
        filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.25));
        opacity: 0.95;
    }

    @media (max-width: 768px) {
        .content {
            padding-bottom: 48px;
        }
        .scribble {
            left: -0.3em;
            top: 10px;
        }
    }

    @media (max-width: 420px) {
        .title {
            line-height: 1.08;
            letter-spacing: 0.01em;
        }
        .scribble {
            width: 8.8em;
        }
    }
`}</style>


            {/* 👇 important: push content BELOW fixed hero */}
            <Box
                id="fleet"
                sx={{
                    position: "relative",
                    zIndex: 3,
                    pt: `${bannerHeight()}px`,
                    background: "#fff"
                }}
            >
                <Box sx={{ mb: { xs: 2, md: 6 }, background: "#fff" }}>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(4, 1fr)' },
                            gap: 3,
                            px: { xs: 2, md: 4 },
                            py: { xs: 4, md: 6 },
                            justifyItems: 'center',
                            alignItems: 'stretch',
                            maxWidth: 1200,
                            margin: '0 auto',
                            "&::before": {
                                content: '""',
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                height: { xs: 80, md: 140 },
                                background: "linear-gradient(180deg, #FFFFFF 0%, rgba(255,255,255,0) 100%)",
                                pointerEvents: "none",
                                zIndex: 0,
                            },
                        }}
                    >
                        {[
                            {
                                icon: '/images/bannerImage/Vector2.svg',
                                title: 'Chat Support',
                                subtitle: 'Please login first to chat',
                                button: 'Let’s Chat',
                                href: `https://wa.me/${CHAT_NUMBER}`
                            },
                            {
                                icon: '/images/bannerImage/Vector3.svg',
                                title: 'Email Support',
                                subtitle: 'Email your queries',
                                button: 'Send Email',
                                href: "mailto:info@royalsmartlimousine.com"
                            },
                            {
                                icon: '/images/bannerImage/Vector4.svg',
                                title: 'Help Centre',
                                subtitle: 'We’re here to help 24/7',
                                button: 'Call Now',
                                href: `https://wa.me/${CHAT_NUMBER}`
                            },
                            {
                                icon: '/images/bannerImage/Vector5.svg',
                                title: 'Visit us',
                                subtitle: 'Visit our office HQ',
                                button: 'View Map',
                                href: 'https://maps.app.goo.gl/vQp4Q441APE8ECEM8'
                            },
                        ].map((card, i) => (
                            <CardBox key={i} {...card} />
                        ))}
                    </Box>
                </Box>

                {/* <Box sx={{ mt: 4, }}>
                <Heading title="Still have any query ? " subtitle="Make journey comfortable with" />
            </Box> */}
                <ContactEnquiry />
                <Box sx={{ py: 4, px: { xs: 2, md: 4 }, background: '#fff' }}>
                    <RslSuperAppBanner />
                </Box>

                <FooterRSL bgcolor="#f8f8f8" />
            </Box>
            <style jsx>{`
  .hero {
    position: relative;
    width: 100%;
    // min-height: clamp(60vh, 72vh, 80vh);
    min-height: ${bannerHeight()};
    border-radius: 0;
    isolation: isolate;
  }

  .content {
    position: absolute;
    inset: 0;
    z-index: 2;
    display: grid;
    place-items: end center;
    padding: clamp(16px, 4vw, 28px);
    align-content: end;
    gap: clamp(16px, 3vh, 28px);
    padding-bottom: clamp(36px, 10vh, 40px);
    text-align: center;
  }

  .title {
    color: #ffffff;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 1.1;
    margin: 0;
    font-size: clamp(28px, 6.5vw, 52px);
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
  }

  .scribble-wrap {
    position: relative;
    display: inline-block;
  }

  .scribble-text {
    position: relative;
    z-index: 2;
  }

  .scribble {
    position: absolute;
    z-index: 1;
    left: -0.1em;
    top: -10px;
    width: clamp(7.5em, 14vw, 13em);
    height: auto;
    transform: rotate(-4deg);
    pointer-events: none;
    filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.25));
    opacity: 0.95;
  }

  @media (max-width: 768px) {
    .content {
      padding-bottom: 48px;
    }
    .scribble {
      left: -0.3em;
      top: 10px;
    }
  }

  @media (max-width: 420px) {
    .title {
      line-height: 1.08;
      letter-spacing: 0.01em;
    }
    .scribble {
      width: 8.8em;
    }
  }
`}</style>
        </>
    )
}
export default ContactUs

export async function getServerSideProps(context) {
    const rawPath = context.resolvedUrl;
    let path = rawPath.split("?")[0];
    if (path.length > 1 && path.endsWith("/")) {
        path = path.slice(0, -1);
    }
    const metaHome = await fetchSeoByPage(path);
    return {
        props: { meta: metaHome }
    };
}